<template>
    <div id="permissible">
        <ul class="p-0">
            <template v-for="(permissibleCategory, pcIndex) in permissibleCategories">
                <li :key="'permissibleCategory' + pcIndex">
                    <div class="d-flex align-items-baseline">
                        <input :disabled="viewOnly" @click="checkAll(pcIndex)" class="permissible-category" type="checkbox" :id="uniqueIdentifier + 'pcCheckbox' + pcIndex">
                        <label class="w-100 collapsed clickable" for=""  data-toggle="collapse" :data-target="'#permissibles' + pcIndex" aria-expanded="false" :aria-controls="'permissibles' + pcIndex">
                            <span>{{ permissibleCategory.n }}</span>
                            <i class="fas fa-chevron-up float-right"></i>
                        </label>
                    </div>
                    <ul>
                        <template v-for="(permissible, pIndex) in permissibleCategory.p">
                            <li :id="'permissibles' + pcIndex" :key="'permissible' + pIndex" class="collapse" data-parent="#permissible">
                                <div class="d-flex align-items-baseline">
                                    <input :disabled="viewOnly" v-model="selectedPermissibles" :value="permissible.i" :class="'permissible pCheckbox' + pcIndex" type="checkbox" :id="uniqueIdentifier + 'pc' + pcIndex + 'pCheckbox' + pIndex">
                                    <label :for="uniqueIdentifier + 'pc' + pcIndex + 'pCheckbox' + pIndex">{{ permissible.n }}</label>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <hr v-if="pcIndex !== permissibleCategories.length - 1">
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    'props': {
        'value': {},
        'viewOnly': {
            'required': true
        },
        'uniqueIdentifier': {
            'required': true
        },
        'isFullBenefits': {
            'required': false,
            'default': false
        }
    },
    data () {
        return {
            'permissibleCategories': null
        };
    },
    'computed': {
        'selectedPermissibles': {
            get () {
                this.$nextTick(() => {
                    this.setCheckAllIcon();
                });
                return this.value;
            },
            set (val) {
                this.$emit('input', val);
                this.$nextTick(() => {
                    this.setCheckAllIcon();
                });
            }
        }
    },
    'watch': {
        isFullBenefits (val) {
            // check if full benefits
            if (val) {
                for (var permissibleCategory of this.permissibleCategories) {
                    for (var permissible of permissibleCategory.p) {
                        this.selectedPermissibles.push(permissible.i);
                    }
                }
            }
        }
    },
    'methods': {
        getPermissibles () {
            this.axios.get('Permissible/GetAll')
                .then(response => {
                    this.permissibleCategories = response.data.data;
                });
        },
        checkAll (pcIndex) {
            var checkall = document.getElementById(this.uniqueIdentifier + 'pcCheckbox' + pcIndex);
            var permissibleCategory = this.permissibleCategories[pcIndex];

            if (checkall.checked === true) {
                for (var permissible of permissibleCategory.p) {
                    for (var [index, selectedPermissible] of this.selectedPermissibles.entries()) {
                        if (permissible.i === selectedPermissible) {
                            this.selectedPermissibles.splice(index, 1);
                        }
                    }
                }
                for (permissible of permissibleCategory.p) {
                    this.selectedPermissibles.push(permissible.i);
                }
            } else if (checkall.checked === false) {
                for (permissible of permissibleCategory.p) {
                    for ([index, selectedPermissible] of this.selectedPermissibles.entries()) {
                        if (permissible.i === selectedPermissible) {
                            this.selectedPermissibles.splice(index, 1);
                        }
                    }
                }
            }
        },
        setCheckAllIcon () {
            for (var [index, permissibleCategory] of this.permissibleCategories.entries()) {
                var checkall = document.getElementById(this.uniqueIdentifier + 'pcCheckbox' + index);

                var tempArray = [];
                for (var permissible of permissibleCategory.p) {
                    for (var selectedPermissible of this.selectedPermissibles) {
                        if (permissible.i === selectedPermissible) {
                            tempArray.push(selectedPermissible);
                        }
                    }
                }

                if (tempArray.length <= 0) {
                    checkall.checked = false;
                    checkall.indeterminate = false;
                } else if (tempArray.length >= permissibleCategory.p.length) {
                    checkall.checked = true;
                    checkall.indeterminate = false;
                } else {
                    checkall.checked = false;
                    checkall.indeterminate = true;
                }
            }
        },
        isCollapsed (id) {
            var label = document.getElementById(id);
            if (label.classList.contains('collapsed')) {
                return true;
            }

            return false;
        }
    },
    mounted () {
        // Get list of permissible
        this.getPermissibles();
    }
};
</script>

<style scoped>
    ul {
        list-style: none;
    }

    .permissible-category, .permissible {
        margin-right: 10px;
    }

    .clickable {
        cursor: pointer;
    }

    label.collapsed i {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }
</style>
